import { Outlet } from 'react-router-dom';
import { SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { IntranetSidebar } from '@/components/IntranetSidebar';
import { ProtectedRoute } from '@/components/ProtectedRoute';
export default function Intranet() {
  return <ProtectedRoute>
      <SidebarProvider>
        <div className="min-h-screen flex w-full">
          <IntranetSidebar />
          <div className="flex-1 flex flex-col">
            <header className="h-14 flex items-center border-b bg-background px-4">
              <SidebarTrigger />
              
            </header>
            <main className="flex-1 p-6">
              <Outlet />
            </main>
          </div>
        </div>
      </SidebarProvider>
    </ProtectedRoute>;
}